import { Dispatch, JSX, SetStateAction } from "react";
import {
  BarChartOptions,
  DeliveryWithExtras,
  SalesBreakdownData,
  SalesOverviewOptions,
} from "@/app/types/types";
import { User } from "../../context/user-context";
import SalesBreakDown from "./sales-break-down/sales-break-down";
import Overview from "./overview/overview";
import LeaderBoard from "./leaderboard/leaderboard";
import Deliveries from "./deliveries/deliveries";

interface MobileDashProps {
  setLoading: Dispatch<SetStateAction<boolean>>;
  loading: boolean;
  salesData: SalesBreakdownData;
  salesChart: JSX.Element | undefined;
  frontGrossChart: JSX.Element | undefined;
  backGrossChart: JSX.Element | undefined;
  selectedSalesOverviewOption: SalesOverviewOptions | undefined;
  setSelectedSalesOverviewOption: Dispatch<
    SetStateAction<SalesOverviewOptions>
  >;
  setSalesRange: Dispatch<SetStateAction<"MTD" | "WTD" | "YTD">>;
  setOverviewRange: Dispatch<SetStateAction<"MTD" | "WTD" | "YTD">>;
  overviewRange: "MTD" | "WTD" | "YTD";
  dealStatusOptions: BarChartOptions;
  saleTypeOptions: BarChartOptions;
  unitsByPaymentTypeOptions: BarChartOptions;
  setGtgEnabled: Dispatch<SetStateAction<boolean>>;
  gtgEnabled: boolean;
  primaryUserGroup: string | undefined;
  deliveries: Record<string, DeliveryWithExtras[]>;
  userPermissions: string[];
  user: User | undefined;
}

export default function MobileDashboard({
  setLoading,
  loading,
  setGtgEnabled,
  gtgEnabled,
  salesChart,
  salesData,
  frontGrossChart,
  backGrossChart,
  setSalesRange,
  overviewRange,
  setOverviewRange,
  setSelectedSalesOverviewOption,
  selectedSalesOverviewOption,
  dealStatusOptions,
  saleTypeOptions,
  unitsByPaymentTypeOptions,
  primaryUserGroup,
  deliveries,
  userPermissions,
  user,
}: MobileDashProps) {
  const ranges: Array<"MTD" | "WTD" | "YTD"> = ["MTD", "WTD", "YTD"];

  return (
    <div className="flex flex-col gap-4 pb-8">
      {/* Range tabs */}
      <div className="flex rounded-lg border border-border overflow-hidden">
        {ranges.map((r) => (
          <button
            key={r}
            onClick={() => {
              setSalesRange(r);
              setOverviewRange(r);
              setLoading(true);
            }}
            className={`flex-1 py-2 text-sm font-medium transition-colors ${
              overviewRange === r
                ? "bg-[#43d662] text-white"
                : "bg-background text-muted-foreground hover:bg-muted"
            }`}
          >
            {r}
          </button>
        ))}
      </div>

      <SalesBreakDown
        loading={loading}
        salesData={salesData || ({} as SalesBreakdownData)}
        salesChart={salesChart || <></>}
        frontGrossChart={frontGrossChart}
        backGrossChart={backGrossChart}
        selectedSalesOverviewOption={
          selectedSalesOverviewOption ?? { label: "", value: "" }
        }
        setSelectedSalesOverviewOption={setSelectedSalesOverviewOption}
      />

      <Overview
        loading={loading}
        setGtgEnabled={setGtgEnabled}
        gtgEnabled={gtgEnabled}
        overviewRange={overviewRange}
        saleTypeOptions={saleTypeOptions}
        dealStatusOptions={dealStatusOptions}
        unitsByPaymentTypeOptions={unitsByPaymentTypeOptions}
      />

      <LeaderBoard
        loading={loading}
        overviewRange={overviewRange}
        gtgOnly={gtgEnabled}
        primaryUserGroup={primaryUserGroup || ""}
      />

      <Deliveries
        deliveries={deliveries}
        userPermissions={userPermissions}
        user={user!}
      />
    </div>
  );
}
